import React from 'react';
import ParentWidget, { ParentWidgetProps } from './ParentWidget';
import KPIBody from './KPIBody';
import type { KPIData } from './KPIBody';

export type KPIHomeWidgetProps = Omit<ParentWidgetProps<KPIData>, 'children'> & {
  formatValue?: (value: number) => number;
};

export function KPIHomeWidget({ formatValue, ...props }: KPIHomeWidgetProps) {
  return (
    <ParentWidget<KPIData>
      {...props}
      isEmpty={(d) => !d || Number.isNaN(d.value)}
    >
      {({ data, metadata, context, helpers }) => {
        const formatted =
          data && formatValue
            ? { ...data, value: formatValue(data.value) }
            : data;
        return (
          <KPIBody
            data={formatted}
            metadata={metadata}
            context={context}
            helpers={helpers}
          />
        );
      }}
    </ParentWidget>
  );
}
